/**
 * Configuration constants for TreeGraphBackground
 */

import type { Color } from "./types";

// Tree structure
export const DEFAULT_TREE_DEPTH = 6;

// Animation (in viewport height percentages)
export const WAVE_SPEED_VH = 0.1; // vh per ms (0.15% of viewport height per ms)
export const WAVE_FALLOFF_VH = 30; // vh - distance for wave brightness falloff
export const FADE_DISTANCE_VH = 60; // vh - distance over which paths fade out after wave passes
export const GLOW_RADIUS = 20; // pixels - kept in pixels as it's a visual effect size

// Visual
export const COLORS: Record<"empty" | "alive" | "dead", Color> = {
  empty: { r: 107, g: 114, b: 128 }, // gray-500
  alive: { r: 251, g: 191, b: 36 }, // amber-400
  dead: { r: 239, g: 68, b: 68 }, // red-500
} as const;

// Canvas
export const CANVAS_OPACITY = 1.0;
export const BACKGROUND_GRADIENT_OPACITY = 0.8;
export const CANVAS_SCALE = 1.15; // Scale canvas to 120% of viewport for overflow
export const TREE_ASPECT_RATIO = 1.8; // Fixed width/height ratio (3:2)

// Node rendering
export const NODE_RADIUS = {
  base: 3,
  active: 4,
  wave: 2, // additional radius during wave
} as const;

// Path rendering
export const PATH_WIDTH = {
  base: 2,
  active: 3,
  wave: 3, // additional width during wave
} as const;

// Alpha values
export const ALPHA = {
  empty: 0.0,
  aliveBase: 0.2,
  aliveWave: 0.5,
  dead: 0.5,
  nodeEmpty: 0.0,
  nodeAliveBase: 0.2,
  nodeAliveWave: 0.5,
  nodeDead: 0.5,
} as const;
